import React, { useState, useEffect } from "react";
import "./dashboard.css";
import Card from "../card/Card";
import Report from "../report/Report";
import RecentSales from "../recentsales/RecentSales";
import TopSelling from "../topselling/TopSelling";
import RecentActivity from "../recentactivity/RecentActivity";
import BuddingReport from "../buddingreport/BuddingReport";
import WebTraffic from "../webtraffic/WebTraffic";
import News from "../news/News";
import api from "../../api/config";

const Dashboard = () => {
  const [cards, setCards] = useState([]);

  // const fetchData = () => {
  //   fetch("http://localhost:4500/cards")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       console.log(data);
  //       setCards(data);
  //     })
  //     .catch((e) => console.log(e.message));
  // };

  const fetchData = async () => {
    try {
      const response = await api.get("/cards"      , {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      setCards(response.data.data);
    } catch (err) {
      console.error(`Error:${err.message}`);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <section className="dashboard section">
      <div className="row">
        <div className="col-lg-8">
          <div className="row">
            {cards &&
              cards.length > 0 &&
              cards.map((card) => <Card key={card.id} card={card} />)}
            <div className="col-12">
              <Report />
            </div>
            <div className="col-12">
              <RecentSales />
            </div>
            <div className="col-12">
              <TopSelling />
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <RecentActivity />
          <BuddingReport />
          <WebTraffic />
          <News />
        </div>
      </div>
    </section>
  );
};

export default Dashboard;
